module.exports = __webpack_public_path__ + "media/images/icons/club_bi_benefits_new-202b301520435decada5bb6ac89de1b0.svg";